
import { RouteNamesEnum } from "@service/router/RouteNamesEnum";
import { mainActions } from "@service/store/main/actions";
import { Vue, Component } from "vue-property-decorator";

@Component({})

export default class PartnerActions extends Vue {
    linkCopied = false;

    copyTimeout: NodeJS.Timeout | null = null;

    copyLink(id: string) {
        const { href } = this.$router.resolve({
            name: RouteNamesEnum.partner,
            params: {
                backend: this.$route.params.backend,
                eventId: this.$route.params.eventId,
                id: id
            }
        });

        navigator.clipboard.writeText(`${location.origin}${href}`);

        this.linkCopied = true;

        if(this.copyTimeout) {
            clearTimeout(this.copyTimeout)
        }

        this.copyTimeout = setTimeout(() => {
                this.linkCopied = false;
        }, 5000);
    }

    async goToEdit(id: string) {
        if(!this.isAdmin) {
            return
        }

        if(!this.isOnEditing) {
            await this.$store.dispatch(mainActions.onIsOnEditing);
        }

        if(this.isOnEditing) {
            this.$router.push({
                name: RouteNamesEnum.partner,
                params: {
                    id: id,
                    eventId: this.$route.params.eventId,
                    backend: this.$route.params.backend
                }
            })
        }
    }

    private get isAdmin(): boolean {
        return this.$store.getters['isAdmin'];
    }

    get isOnEditing() {
        return this.$store.state.isOnEditing;
    }
}
